import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';
import {UploadService} from './upload.service';

@Injectable({
    providedIn: 'root'
})
export class StudentQualificationService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService,
                public fileUploadService: UploadService) {
        super(http, alertService, globalService);
    }

    get(): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.STUDENT_QUALIFICATION_DETAILS());
    }

    getByCounsellor(id): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.STUDENT_QUALIFICATION_DETAILS(id));
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.STUDENT_QUALIFICATION_DETAILS(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.STUDENT_QUALIFICATION_DETAILS(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.STUDENT_QUALIFICATION_DETAILS(id), data);
    }
}
